import {
  LOAD_CONFIGURATION,
  LOAD_CONFIGURATION_ERROR,
  LOAD_CONFIGURATION_SUCCESS,
  LOAD_QUOTES,
  LOAD_QUOTES_ERROR,
  LOAD_QUOTES_SUCCESS,
  SET_QUOTE_EDIT,
} from '../constants/custom-quotes';

export const LoadConfiguration = () => ({
  type: LOAD_CONFIGURATION
});

export const LoadConfigurationError = error => ({
  type: LOAD_CONFIGURATION_ERROR,
  error,
});

export const LoadConfigurationSuccess = ({ assets, strategies }) => ({
  type: LOAD_CONFIGURATION_SUCCESS,
  assets,
  strategies
});

export const LoadQuotes = () => ({
  type: LOAD_QUOTES
});

export const LoadQuotesError = error => ({
  type: LOAD_QUOTES_ERROR,
  error,
});

export const LoadQuotesSuccess = ({ quotes, msg }) => ({
  type: LOAD_QUOTES_SUCCESS,
  quotes,
  msg
});

export const SetQuoteEdit = ({ quote }) => ({
  type: SET_QUOTE_EDIT,
  quote,
});
